var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "AuthCard",
    { staticClass: "font-raleway", attrs: { title: "Invitation sign in" } },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid, dirty, handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.submit)
                      },
                    },
                  },
                  [
                    _c("ValidationProvider", {
                      attrs: { name: "username", rules: "c_email|required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, touched }) {
                              return [
                                _c("FormGroup", {
                                  attrs: {
                                    id: "username",
                                    title: "Email Address",
                                    name: "username",
                                    type: "email",
                                    placeholder: "Enter your email *",
                                    errors:
                                      touched && errors.length > 0
                                        ? ["Email Address is required"]
                                        : [],
                                  },
                                  model: {
                                    value: _vm.username,
                                    callback: function ($$v) {
                                      _vm.username =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "username",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      staticClass: "mt-6",
                      attrs: { name: "temporaryPassword", rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, touched }) {
                              return [
                                _c("FormGroup", {
                                  attrs: {
                                    id: "temporaryPassword",
                                    title: "Temp Password",
                                    name: "temporaryPassword",
                                    type: "password",
                                    placeholder:
                                      "Enter the temporary password *",
                                    errors: touched ? errors : [],
                                  },
                                  model: {
                                    value: _vm.temporaryPassword,
                                    callback: function ($$v) {
                                      _vm.temporaryPassword = $$v
                                    },
                                    expression: "temporaryPassword",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      staticClass: "mt-6",
                      attrs: {
                        name: "newPassword",
                        rules: "password_len|required",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, touched }) {
                              return [
                                _c("FormGroup", {
                                  attrs: {
                                    id: "newPassword",
                                    title: "New Password",
                                    name: "newPassword",
                                    type: "password",
                                    placeholder: "Enter your password *",
                                    errors:
                                      touched && errors.length > 0
                                        ? ["New Password is required"]
                                        : [],
                                  },
                                  model: {
                                    value: _vm.newPassword,
                                    callback: function ($$v) {
                                      _vm.newPassword = $$v
                                    },
                                    expression: "newPassword",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("ValidationProvider", {
                      staticClass: "mt-6",
                      attrs: {
                        name: "confirm",
                        rules: "password:@newPassword|required",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, touched }) {
                              return [
                                _c("FormGroup", {
                                  attrs: {
                                    id: "confirm",
                                    title: "Confirm Password",
                                    name: "confirm",
                                    type: "password",
                                    placeholder: "Confirm your password *",
                                    errors:
                                      touched && errors.length > 0
                                        ? ["Re-enter your password"]
                                        : [],
                                  },
                                  model: {
                                    value: _vm.confirmPassword,
                                    callback: function ($$v) {
                                      _vm.confirmPassword = $$v
                                    },
                                    expression: "confirmPassword",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("UiButton", {
                      staticClass: "my-6 block w-full",
                      attrs: {
                        buttonText: "Sign in",
                        type: "submit",
                        fullWidth: "",
                        processing: _vm.loading,
                        disabled: invalid || !dirty,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }